import React from "react";
import Link from "next/link";
import styles from "./scholarship_card.module.scss";
import { BsCalendar, BsCashStack } from "react-icons/bs";
import moment from "moment-timezone";

export const ScholarshipCard = ({
  name,
  amount,
  deadline,
  link,
  badge,
  countryCurrencySymbol,
  ...props
}) => {
  return (
    <div className={styles.scp_card}>
      {badge && badge.length > 0 && (
        <ul className={styles.scp_card_tags}>
          {badge.map((item, i) => (
            <li
              key={i}
              className={i % 2 === 0 ? styles.exclusive : styles.applicant}
            >
              {item}
            </li>
          ))}
        </ul>
      )}

      <Link legacyBehavior href={link || "#"}>
        <a>
          <h3 className={styles.scp_card_title}>{name}</h3>
        </a>
      </Link>
      <ul className={styles.scp_card_info_lists}>
        {amount && (
          <li>
            <BsCashStack className={styles.scp_card_icon} />
            <div className={styles.scp_card_text}>
              <span>Value</span>

              <span>
                {countryCurrencySymbol}
                {parseInt(amount)}
              </span>
            </div>
          </li>
        )}

        {deadline && (
          <li>
            <BsCalendar className={styles.scp_card_icon} />
            <div className={styles.scp_card_text}>
              <span>Deadline</span>
              <span>{moment(deadline).format("Do MMMM, YYYY")}</span>
            </div>
          </li>
        )}
      </ul>

      <Link legacyBehavior href={link || "#"}>
        <a className={`${styles.scp_card_link} btn btn-primary btn-md`}>
          More Details
        </a>
      </Link>
    </div>
  );
};

export default ScholarshipCard;
